import { useMutation } from '@tanstack/react-query';
import { ApiResponse, parseNetworkError, success } from "../../../../../api/api-response";
import { RestEndpoints } from "../../../../../api/endpoints";
import { getInstanceMultipartFormData } from "../../../../../utils/rest";
import { IPomAnnouncementExcelDataModel } from "../../../models/announcements/pom-announcement-excel-data.model";

const extractAnnouncementTemplateData = async (
  file: File,
  contractId: number,
): Promise<ApiResponse<IPomAnnouncementExcelDataModel>> => {
  try {
    const form = new FormData();
    form.append("file", file);
    const url = RestEndpoints.PomAnnouncementExtractExcel.replace(":contractId", contractId.toString());
    const { data } = await getInstanceMultipartFormData().post(url, form);
    return success(data);
  } catch (error) {
    return parseNetworkError(error);
  }
};

export const useExtractAnnouncementTemplateDataQuery = () => {
  return useMutation({
    mutationFn: ({ file, contractId }: { file: File; contractId: number }) => extractAnnouncementTemplateData(file, contractId)
  });
};
